import { AuthProvider as OidcProvider } from "react-oidc-context";
import config from "./config.js"

const baseURL = config.baseURL
const serverURL = config.partnersBridgeBackendApiURL
const realm = config.keycloakConfig.realm.includes('stage') ? 'stage' : 'production';

const oidcConfig = {
  authority: `${config.keycloakConfig.url}/realms/${config.keycloakConfig.realm}`,
  client_id: config.keycloakConfig.clientID,
  redirect_uri: `${baseURL}/openid/auth`,
  response_type: "code",
  disablePKCE: false,
  loadUserInfo: true,
  scope: "openid profile email address",
  post_logout_redirect_uri: `${baseURL}`,
};

export const getRealm = (() => { return realm });

export const getRestServer = (() => { return serverURL });

export const AuthProvider = ({ children }) => {
  return (
    <OidcProvider {...oidcConfig}>
      {children}
    </OidcProvider>
  );
};